import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
const CategoryFilter = ({ products, activeCategory, onCategoryChange, variant = 'horizontal', }) => {
    const categories = useMemo(() => {
        const seen = new Map();
        products.forEach(p => {
            p.categories.forEach(c => {
                if (!seen.has(c.slug))
                    seen.set(c.slug, c);
            });
        });
        return Array.from(seen.values()).sort((a, b) => a.name.localeCompare(b.name));
    }, [products]);
    if (categories.length === 0)
        return null;
    return (_jsxs("div", { className: `eno-category-filter${variant === 'sidebar' ? ' eno-category-filter--sidebar' : ''}`, children: [_jsx("button", { type: "button", className: `eno-cat-btn${!activeCategory ? ' active' : ''}`, onClick: () => onCategoryChange(''), children: "All" }), categories.map(cat => (_jsx("button", { type: "button", className: `eno-cat-btn${activeCategory === cat.slug ? ' active' : ''}`, onClick: () => onCategoryChange(cat.slug), children: cat.name }, cat.slug)))] }));
};
export default CategoryFilter;
